export default () => ({
  previewViewerModalOpen: false,
  documentDetails: {},
  textContent: null,
});
